import { createContext } from 'react';
import { License } from './ProfileContext';

type SelectedGameContextType = {
    currLicense: License;
};

const SelectedGameContext = createContext<SelectedGameContextType>({
    currLicense: {
        key: 'undefined-license',
        name: 'Undefined Game',
    },
});

export default SelectedGameContext;

interface SelectedGameContextProviderProps {
    currLicense: License;
}

export const SelectedGameContextProvider: React.FC<SelectedGameContextProviderProps> = ({
    currLicense,
    children,
}) => {
    return (
        <SelectedGameContext.Provider
            value={{
                currLicense,
            }}
        >
            {children}
        </SelectedGameContext.Provider>
    );
};
